import { FC } from "preact/compat";
import { getMe, requestApi } from "~/core";
import EmblemIcon from "~/assets/emblem.svg";
import LogoutIcon from "@material-design-icons/svg/outlined/logout.svg";

const Header: FC = () => {
    const { me, refetch } = getMe();

    const handleLogout = async () => {
        await requestApi("/auth/logout", "POST");
        refetch();
    };

    return (
        <header
            style={{
                background:
                    "linear-gradient(270.02deg, #29465B 0%, #7A0E4F 28.56%, #09508E 69%, #29465B 97.48%)",
            }}
            className="w-full flex items-center py-2 min-h-[50px]"
        >
            <div className="p-2 border-r border-white border-opacity-25 min-w-[50px]">
                <EmblemIcon className="w-[30px]" />
            </div>
            <div className="flex items-center justify-end w-full px-4">
                {me.value && (
                    <div className="flex items-center text-white fill-current">
                        <span className="mr-1 text-sm">{me.value.email}</span>
                        <button
                            type="button"
                            title="Logout"
                            onClick={handleLogout}
                            className="p-2 transition duration-100 rounded-full outline-none hover:bg-white/20 focus:ring focus:ring-white"
                        >
                            <LogoutIcon width="18" height="18" />
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
